import axios from 'axios';
import PropTypes from 'prop-types';
import React, { memo, useCallback, useState } from 'react';
import { Col, Form, Row, Spinner } from 'react-bootstrap';
import Button from '../../../shared/components/Button';
import FormControl from '../../../shared/components/Form/FormControl';
import ResponsiveHeader from '../../../shared/components/ResponsiveHeader';
import { useTranslation } from 'react-i18next';

const HaveMoreQuestions = memo(({
  id,
  title,
}) => {
  const [question, setQuestion] = useState('');
  const [loading, setLoading] = useState(false);
  const [messageStatus, setMessageStatus] = useState('');
  const { t } = useTranslation();

  const handleSendQuestion = useCallback(() => {
    setLoading(true);
    setMessageStatus('');
    axios.post('/api/v1/influencers/influencers/mail_question', {
      influencer: {
        question
      }
    })
      .then(() => {
        setMessageStatus('success');
      })
      .catch(() => {
        setMessageStatus('error');
      })
      .finally(() => {
        setQuestion('');
        setLoading(false);
      });
  });

  return (
    <section id={id} className="auto-padding-section mb-6">
      <ResponsiveHeader className='mb-4' xs='h4' md='h3'>
        {title}
      </ResponsiveHeader>
      <div className="body-1 mb-4">
        {t('influencers.pages.learning_center.more_questions_desc')}
      </div>
      <Row className='justify-content-end'>
        <Col xs={12} className="mb-4">
          <Form.Group>
            <FormControl placeholder={t('influencers.common.text')}
              textarea
              value={question}
              onChange={(e) => setQuestion(e.target.value)} />
            {messageStatus === 'success' &&
              <Form.Text>
                <i className='fal fa-check-circle text-success mr-2' />
                {t('influencers.pages.learning_center.message_sent')}
              </Form.Text>
            }
            {messageStatus === 'error' &&
              <Form.Text>
                <i className='fal fa-exclamation-circle text-success mr-2' />
                {t('influencers.pages.learning_center.message_error')}
              </Form.Text>
            }
          </Form.Group>
        </Col>
        <Col className="col-auto">
          <Button variant="primary"
            disabled={!question || loading}
            onClick={handleSendQuestion}>
            {loading
              ? <Spinner animation="border" size="sm" />
              : t('influencers.common.send')
            }
          </Button>

        </Col>
      </Row>

    </section >
  );
});

HaveMoreQuestions.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
HaveMoreQuestions.defaultProps = {
};

export default HaveMoreQuestions;
